export default "__VITE_PUBLIC_ASSET__bd0b48ba__"